import { LAxios } from "../axios";
import { catchHandler } from "../catch-handler";
import { UserListInput, UserListOutput } from "./type";

export const usersList = async (
  data?: UserListInput,
): Promise<UserListOutput | string | undefined> => {
  try {
    const params = new URLSearchParams();
    params.append("phoneNumber", data?.phoneNumber || "");
    params.append("email", data?.email || "");
    params.append("accountId", data?.accountId || "");
    params.append("userId", data?.userId || "");
    params.append("date", data?.date || "");
    params.append("firstName", data?.firstName || "");
    params.append("lastName", data?.lastName || "");

    const queryString = params.toString();

    const response = await LAxios.get(`users/list/?${queryString}`, {
      headers: {
        "x-include-skip": data?.skip,
        "x-include-limit": data?.limit,
      },
    });
    return response.data;
  } catch (error) {
    return catchHandler<UserListOutput | string | undefined>(
      error,
      data,
      usersList,
      {},
    );
  }
};
